{
  "anasayfa": {
    "Aylık Devam Grafiği": "Monthly Attendance Chart",
    "Bekleyen Anket": "Pending Survey",
    "Doğum Günleri": "Birthdays",
    "Mesai İzin": "Overtime Leave",
    "Müsait olduğunuzda lütfen bekleyen anketlerinizi tamamlayınız": "Please complete your pending surveys when you are available.",
    "Resmi Günler": "Public Holidays",
    "Resmi Tatil": "Public Holiday",
    "Takvim Yükleniyor": "Loading Calendar",
    "Özel Günler": "Special Days",
    "İzinler": "Leaves",
    "Proje Sayısı ve Durumları": "Project Count and Status",
    "Proje Sayısı": "Project Count",
    "Çalışma Oranı": "Work Ratio",
    "Proje & Genel": "Project & General",
    "Proje ve Genel Saat": "Project and General Hours",
    "Performans Hariç": "Excluding Performance",
    "Proje Oranı": "Project Ratio",
    "Doğum Günü Yaklaşanlar": "Upcoming Birthdays",
    "Yaş": "Age",
    "Veri çekilirken bir hata oluştu": "An error occurred while fetching data",
    "Bilgiler": "Information",
    "Takvim": "Calendar",
    "Bağlantı Arşivi": "Link Archive",
    "Hızlı erişim için önemli bağlantılar": "Important links for quick access",
    "Dosya Arşivi": "File Archive",
    "Sistem dökümanları ve indirilebilir dosyalar": "System documents and downloadable files",
    "AÇ": "OPEN",
    "Randevu Katılım Onay": "Appointment Attendance Confirmation",
    "Konum Bilgi Hatası": "Location Information Error",
    "Saat": "Time",
    "Müşteri": "Customer",
    "İşlem": "Action",
    "Katılmadım": "Did Not Attend",
    "Katıldım": "Attended",
    "Yaklaşan Doğum Günleri": "Upcoming Birthdays",
    "Bu ay kutlanacak özel günler": "Special days to celebrate this month",
    "Yaş Yılı": "Years Old",
    "Bugün": "Today",
    "Gün Kaldı": "Days Left",
    "Ay": "Month",
    "Müşteri Yetki Talep": "Customer Permission Request",
    "On The Jobtraining": "On The Job Training",
    "One To One": "One To One"
  }
}
